<template>
  <router-link to="/categories">
    <div class="page plug" :style="{ backgroundImage: `url(${require('@/assets/img/EAJ_GT_LAVAGNA.jpg')})` }">
    </div>
  </router-link>
  </template>
  
  <script>
  
    const appPlug = {
      name: "Plug",
      data() {
        return {
          someproperty: ""
        }
  
      } 
    };
    export default appPlug;
  </script>
  
  <style lang="scss" scoped>
  .page {
    height: 100%;
    width: 100%;
    display: flex;
    background-color: black;
  }
  .plug {
    background-position: center center;
    background-repeat: none;
    background-size: cover;
  }
  </style>